import { render } from "./AddProdukData.vue?vue&type=template&id=12d24724"
import script from "./AddProdukData.vue?vue&type=script&lang=js"
export * from "./AddProdukData.vue?vue&type=script&lang=js"

import "./AddProdukData.vue?vue&type=style&index=0&id=12d24724&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__